import React, { useCallback } from 'react';
import { dismissFlag as createDismissFlag, ErrorFlag, useFlagService } from '@atlassian/jira-flags';
import { RequestAccessErrorFlag, type CrossJoinTargetProduct } from '@atlassian/cross-join-nudges';
import { generateId } from '../../utils/index.tsx';

export const useMsrRequestAccessErrorFlag = () => {
	const { showFlag, dismissFlag } = useFlagService();
	return useCallback(
		(product: CrossJoinTargetProduct) => {
			const id = `error-${generateId()}`;
			const dismiss = () => dismissFlag(createDismissFlag(id));

			showFlag({
				id,
				render: (props) => (
					<RequestAccessErrorFlag
						{...props}
						id={id}
						targetProduct={product}
						onDismiss={dismiss}
						flagComponent={ErrorFlag}
					/>
				),
			});
		},
		[dismissFlag, showFlag],
	);
};
